export default "__VITE_ASSET__e738f37d__"